<h1 mat-dialog-title class="title-confirm">{{data.header}}</h1>
<mat-dialog-content>{{data.content}}</mat-dialog-content>
@if (!data.isOk) {
  <mat-dialog-actions style="justify-content: end;">
    <button mat-stroked-button cdkFocusInitial (click)="onConfirm(false)">No</button>
    <button mat-stroked-button cdkFocusInitial class="yes" (click)="onConfirm(true)">Yes</button>
  </mat-dialog-actions>
}
@if (data.isOk) {
  <mat-dialog-actions style="justify-content: end;">
    <button mat-stroked-button cdkFocusInitial class="yes" (click)="onConfirm(true)">Ok</button>
  </mat-dialog-actions>
}
